import { create } from "zustand";
import { combine } from "zustand/middleware";

import { HouseholdInformationData } from "@components/forms/household-information/types.ts";

const DEFAULT_HOUSEHOLD_INFORMATION: HouseholdInformationData & {
  isValid: boolean;
} = {
  isValid: true,
  annualConsumption: null,
  gridKwh: { import: null, export: null },
};

export const useHouseholdInformationStore = create(
  combine(DEFAULT_HOUSEHOLD_INFORMATION, (set) => ({
    setPostcode: (postcode: HouseholdInformationData["postcode"]) =>
      set((state) => ({ ...state, postcode })),
    setHasEv: (hasEv: HouseholdInformationData["hasEv"]) =>
      set((state) => ({ ...state, hasEv })),
    setHouseType: (houseType: HouseholdInformationData["houseType"]) =>
      set((state) => ({ ...state, houseType })),
    setHeatingType: (heatingType: HouseholdInformationData["heatingType"]) =>
      set((state) => ({ ...state, heatingType })),
    setMeterType: (meterType: HouseholdInformationData["meterType"]) =>
      set((state) => ({ ...state, meterType })),
    setIsValid: (isValid: boolean) => set((state) => ({ ...state, isValid })),
    setAnnualConsumption: (
      annualConsumption: HouseholdInformationData["annualConsumption"],
    ) => set((state) => ({ ...state, annualConsumption })),
    setGridImportKwh: (
      importKwh: HouseholdInformationData["gridKwh"]["import"],
    ) =>
      set((state) => ({
        ...state,
        gridKwh: { ...state.gridKwh, import: importKwh },
      })),
    setGridExportKwh: (
      exportKwh: HouseholdInformationData["gridKwh"]["export"],
    ) =>
      set((state) => ({
        ...state,
        gridKwh: { ...state.gridKwh, export: exportKwh },
      })),
  })),
);
